import type { FC } from "react";
import React from "react";

import { clsx } from "clsx";

import type { LabelProps } from "@busbud/horizon";
import { Label } from "@busbud/horizon";

import {
  getOriginDestinationLabel,
  origin_destination_max_width_class
} from "@app/components/origin-destination-label/origin-destination-label-utils";

type Props = LabelProps & {
  origin: string;
  destination: string;
  variant?: "one-way" | "roundtrip";
  label_size?: LabelProps["size"];
};

export const OriginDestinationLabel: FC<Props> = ({
  destination,
  origin,
  variant = "one-way",
  className,
  noWrap = true,
  fontWeight = "bold",
  label_size,
  as = "span",
  ...rest
}) => {
  return (
    <Label
      as={as}
      fontWeight={fontWeight}
      className={clsx(
        "block truncate",
        origin_destination_max_width_class,
        className
      )}
      size={label_size}
      {...rest}
    >
      {getOriginDestinationLabel(origin, destination, variant)}
    </Label>
  );
};
